import { render, staticRenderFns } from "./CoachData.vue?vue&type=template&id=4f80c8cc&"
import script from "./CoachData.vue?vue&type=script&lang=js&"
export * from "./CoachData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports